import ReactDOM from 'react-dom'
import { useState, useEffect } from 'react'
import Modal from 'components/Modal/Modal'
import { useAppSelector } from 'redux/hooks'
import { Button, Form } from 'react-bootstrap'
import ReactLoading from 'react-loader-spinner'
import { Status } from 'redux/features/favoris/slice'
import ToastAlert from 'components/ToastAlert'
import {
  makeSelectFavoriStatusCommentaire,
  makeSelectFavoriErrorCommentaire,
} from 'redux/features/favoris/selectors'
import s from '../Modal.module.scss'

interface Props {
  uid: string
  commentaire: string
  show: boolean
  onHide: () => void
  onSubmit: (commentaire: string) => void
}

const ModalCommentaire = ({
  uid,
  show,
  onSubmit,
  onHide,
  commentaire: defaultCommentaire = '',
}: Props): JSX.Element => {
  const statusCommentaire = useAppSelector(
    makeSelectFavoriStatusCommentaire(uid)
  )
  const errorCommentaire = useAppSelector(makeSelectFavoriErrorCommentaire(uid))
  const [commentaire, setCommentaire] = useState(defaultCommentaire || '')
  const node = document.querySelector('.modal')

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    onSubmit(commentaire)
  }

  useEffect(() => {
    if (!defaultCommentaire) setCommentaire('')
  }, [defaultCommentaire])

  return (
    <>
      {node &&
        ReactDOM.createPortal(
          <ToastAlert
            show={statusCommentaire === Status.Failed}
            variant="danger"
          >
            {errorCommentaire}
          </ToastAlert>,
          node
        )}
      <Modal
        additionalModalClassNames={s.modal}
        show={show}
        title="Associer un commentaire"
        body={
          <Form onSubmit={handleSubmit}>
            <h2 className={s.title}>
              Souhaitez-vous associer un commentaire à cette parcelle favorite ?
            </h2>
            <p className={s.text}>
              Vous pouvez aussi ajouter un commentaire libre sur cette parcelle
              enregistrée en favori.
            </p>
            <Form.Group controlId="urlAnnonce">
              <Form.Label className={s.label}>
                Rentrez ici votre commentaire :
              </Form.Label>
              <Form.Control
                className={s.textarea}
                as="textarea"
                type="text"
                value={commentaire}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setCommentaire(e.target.value)
                }
              />
            </Form.Group>
            <div className={s.controls}>
              <Button variant="outline-primary" onClick={onHide}>
                Passer
              </Button>
              <Button variant="primary" type="submit" disabled={!commentaire}>
                {statusCommentaire === Status.Pending ? (
                  <ReactLoading type="Oval" color="#fff" height="2.4rem" />
                ) : (
                  'Enregister'
                )}
              </Button>
            </div>
          </Form>
        }
        onCloseButtonClick={onHide}
      />
    </>
  )
}

export default ModalCommentaire
